<template>
    <div id="">
    <!-- <my-tour v-if="" :steps="steps" name="steps-cadastro-empresas"></my-tour> -->
        <section id="content">
            <div class="container">
                 <TituloPagina titulo="Desempenho dos Funcionários" />
                <div class="card-panel">
                    <div class="flex-row bottom-xs">
                        <div class="col-xs-12 col-sm-6 col-md-2">
                            <label>Data Início</label>
                            <date-picker v-model="filtro.data_ini" format="DD/MM/YYYY" input-class="m-0" class="width-100"></date-picker>
                        </div>
                        <div class="col-xs-12 col-sm-6 col-md-2">
                            <label>Data Fim</label>
                            <date-picker v-model="filtro.data_fim" format="DD/MM/YYYY" input-class="m-0" class="width-100"></date-picker>
                        </div>
                        <div class="col-xs-12 col-md-2" style="position: relative">
                            <label for="autocomplete-input">Incluir Corretor</label>
                            <div class="input-field m-0">
                                <input type="text" id="autocomplete-input" class="autocomplete m-0" autocomplete="off">
                            </div>
                        </div>
                        <div class="col-xs-12 col-md-3">
                            <div class="flex">
                                <i class="material-icons md-32 grey-text clear asc" :class="{active:  filtro.order == 'asc'}"   @click="setOrder('asc')">filter_list</i>
                                <i class="material-icons md-32 grey-text clear desc" :class="{active: filtro.order == 'desc'}"  @click="setOrder('desc')">filter_list</i>
                                <span class="info ml-2" v-html="fraseOrder"></span>
                            </div>
                        </div>

                        <div class="col-xs-12 col-md-3">
                            <button class="btn waves-effect waves-light right hide-on-med-and-down btn-default" @click="downloadPDF">
                                <i class="material-icons left">file_download</i> Exportar
                            </button>
                        </div>
                    </div>

                </div>
                <div class="row">
                    <div class="col m12" style="margin-top: 100px;">
                        <div class="chip mt-3" v-for="(item, i) in added" :key="`funcionario-selecionado-${i}`">
                            {{item}}
                            <i @click="removeItem(item)" class="close material-icons">close</i></div>
                        </div>

                        <div class="small col card-panel m12" >
                            <desempenho-funcionarios @clickFuncionario="getDetalhes" @load="showLoading" :id_franquia="filtro.id_franquia" :filtros.sync="filtro" @removeFuncionario="cleanItem" :addItem= "selectedId" :removeItem="removeId"/>
                        </div>
                    </div>
                </div>
                <!-- Modal Congelar -->
                <div id="modalDetail" class="modal modal-fixed-footer">
                    <div class="modal-content pt-0 pl-0 pr-0">
                        <div class="row">
                            <div class="col s12" style="padding-left: 0; padding-right: 0">
                                <ul class="tabs" ref="tabDetalhes" v-if="showHeader">
                                    <li v-for="(item, index) in details" :key="index" :id='`tab${item.id_estagio}`' @click="handleGetEstadosDetalhes(item, index)" :data-type="item.id_estagio" :class=" item.quantidade == 0 ? 'disabled': ''" class="tab col s4 tab-modal"><a :href="`#aba-${index}`" :class="index == tab ? 'active' : ''" style="font-weight: bold;">{{item.quantidade}} {{item.nome_estagio}}</a></li>
                                </ul>
                                </div>
                                <div v-for="(item, index) in details" :key="index" :id="`aba-${index}`" :class="index == tab ? 'active' : ''" :style="index != tab ? 'display:none' : ''" >
                                    <p class="center pt2" v-if="!modalLoading && getDetailsInfosFetched(item.id_estagio) && getDetailInfo(item.id_estagio).length == 0">Nenhum item...</p>
                                    <table class="striped list" v-if="checkDetailInfo(item.id_estagio)">
                                        <thead>
                                            <tr>
                                                <th class="colConsultor hide-on-med-and-down" style="padding-top: 39px">
                                                    CLIENTE
                                                </th>
                                                <th class="colData hide-on-med-and-down" style="padding-top: 23px">
                                                    DATA
                                                </th>
                                                <th class="colTipo hide-on-med-and-down" style="padding-top: 20px">
                                                    TIPO
                                                </th>
                                                <th class="colStatus" style="padding-top: 20px">
                                                    STATUS
                                                </th>
                                                <th class="colStatus" style="padding-top: 20px">
                                                    OBSERVAÇÕES
                                                </th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(acompanhamento, index) in getDetailInfo(item.id_estagio)">
                                                <td class="group-avatar  hide-on-med-and-down">
                                                    <div style="display: flex; align-items: center; height: 100%">
                                                        <i v-if="!acompanhamento.cliente.avatar" class="material-icons circle">person</i>
                                                        <img style="height:40px; width: 40px;" v-if="acompanhamento.cliente.avatar" :src="acompanhamento.cliente.avatar" alt="" class="circle">
                                                        <span class="group-avatar-name ml-1">{{ acompanhamento.cliente.nome }}</span>
                                                    </div>
                                                </td>
                                                <td>
                                                    {{formatDate(acompanhamento.dh_tipo_estado || acompanhamento.dh_criacao_historico)}}
                                                </td>
                                                <td>{{acompanhamento.tipo_pedido}}</td>

                                                <td>{{formatTipoPedido(acompanhamento)}}</td>
                                                <td>{{acompanhamento.observacao}}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                <!-- <Pagination v-if="checkDetailInfo(item.id_estagio)" :perPage="detailInfosGetQtd(item.id_estagio)" :qty="detailInfosTotal(item.id_estagio)" :setCurrent="(current) => setCurrent(current, item.id_estagio)" :current="detailInfosGetCurrent(item.id_estagio)" /> -->
                                </div>

                                <full-loading v-if="modalLoading"  key="something" theme="white" message="Carregando dados..."></full-loading>
                        </div>
                    </div>

                    <div class="modal-footer grey lighten-3">
                        <p class="ml-2 mt-0">OBS.: As informações mostradas neste modal não tem relação com a esteira exibida na dashboard.<br>Estes representam o total de contatos, visitas e negociações independente do número de clientes.</p>
                        <button @click="hideModalDetail()" class="modal-action btn waves-effect waves-light btn-default darken-1">Fechar</button>
                    </div>
                </div>

        </section>
    </div>
</template>
<style lang="scss" scoped>
@import './Funcionario.scss';
@import "@/../../static/assets/css/custom/flex.css";
.flex
{
    display: flex;
}
</style>
<script>
    import Auth from '@/store/auth';
    import TituloPagina from '@/components/common/TituloPagina';
    import MyTour from '@/components/common/MyTour.vue'
    import {  api } from '@/helpers/api';
    import { DONO, GERENTE, CORRETOR, PARCEIRO, MASTER } from '@/constants/funcionarioCargo.js';
    import DATEPICKER  from '@/constants/datepicker.js';
    import DesempenhoFuncionarios from '@/components/charts/DesempenhoFuncionarios';
    import Card from '@/components/common/Card/Card';
    import { Event } from '@/helpers/events';
    import Message from '@/helpers/message';
     import {
        ESTAGIO_PROSPECCAO,
        ESTAGIO_CHAMADA_TELEFONICA,
        ESTAGIO_PRIMEIRA_VISITA,
        ESTAGIO_EFETIVADO,
        ESTAGIO_NEGATIVADO,
        ESTAGIO_SEGUNDA_VISITA,
        ESTAGIO_EM_ESPERA,
        ESTAGIO_NEGOCIACAO,
        ESTAGIO_PERDIDO,
    } from '@/constants/pedidoEstagio.js';
    import ConverterHelper from '@/helpers/converter';
    import FullLoading from '@/components/common/FullLoading';
    import Pagination from '@/components/common/Pagination/Pagination';
    import { download } from '@/pdf/DesempenhoFuncionario';

    export default {
        components: {
            TituloPagina,
            DesempenhoFuncionarios,
            // DesempenhoHistoricoFuncionarios,
            MyTour,
            Card,
            FullLoading,
            Pagination
        },
        data: () => ({
            fraseOrder: '',
            selectedId: null,
            removeId: null,
            added: [],
            selected: null,
            funcionarios: [],
            filtro:{
                data_ini: moment().subtract(90, 'days').toDate(),
                data_fim: new Date,
                order: 'desc'
            },
            showHeader: false,
            details: [],
            modalLoading: true,
            tab: 0,
            detailsInfos: {
                '2': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
                '3': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
                '9': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
            }

        }),
        created() {
        this.setFraseOrder();
        },
        mounted() {

            $(this.$refs.tabDetalhes).tabs();
            const self = this;

            $('#modalDetail').modal();


            api.post(`funcionario/lista-corretores-franquia`, {id_franquia: this.filtro.id_franquia}).then(response => {

                this.funcionarios = response.data.result.data;

                let autosuggestData = {};

                self.funcionarios.forEach(func => {
                    if(func.nome_funcionario){
                        autosuggestData[func.nome_funcionario] = null;
                    }
                })
                $('input.autocomplete').autocomplete({
                    data: autosuggestData,
                    onAutocomplete: function(val){
                        console.log(4444, val);
                        if(!self.added.includes(val)){
                            self.selected = val;
                            self.added.push(val);
                            $('#autocomplete-input').val('');
                        }else{
                             Message.messageError('Corretor já adicionado');
                             self.selectedId = null;
                        }
                    },
                });
            }).catch(err => console.log(err))

        },
        watch:{
            selected(){
               this.selectedId = this.getSelectedId(this.selected);
               this.$emit('selectedId');
            },
            'filtro.data_fim'(){
                this.$emit('filtros');
            },
            'filtro.data_ini'(){
                this.$emit('filtros');
            },
        },
        methods: {
            mapDetails(itens){
                    return itens.filter(detail => {
                        if(detail.id_estagio == ESTAGIO_CHAMADA_TELEFONICA || detail.id_estagio == ESTAGIO_PRIMEIRA_VISITA || detail.id_estagio == ESTAGIO_NEGOCIACAO ){
                            this.detailsInfos[detail.id_estagio].total = detail.quantidade;
                            return true;
                        }
                        return false;
                    });
            },
             downloadPDF(){
                this.showLoading();
                const self = this;
                const dt_ini = moment(self.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                const dt_fim = moment(self.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
                let newFilter = { ...self.filtro };

                if(newFilter.hasOwnProperty('id_funcionario')){
                    delete newFilter.id_funcionario
                }
                api.post('grafico/relatorio-franquias-funcionarios',{...self.filtro, data_ini: dt_ini, data_fim: dt_fim, order: 'desc'}).then(function (response) {
                    download(response.data.result.data, {
                        fileName: `relatorio_funcionario_${self.filtro.data_ini}_${self.filtro.data_fim}`,
                        subTitle: `Data: ${self.filtro.data_ini} a ${self.filtro.data_fim}, Ordenação decrescente lead efetivados`,
                    });
                    self.showLoading(false);
                }).catch(err =>  self.$emit('load', true))

            },
            detailInfosGetCurrent(id_estagio){
                return this.detailsInfos[id_estagio].pagination.current;
            },
            detailInfosGetQtd(id_estagio){
                return this.detailsInfos[id_estagio].pagination.qtd;
            },
            detailInfosTotal(id_estagio){
                return this.detailsInfos[id_estagio].pagination.total;
            },
            getDetailsInfosFetched(id_estagio){
                return this.detailsInfos[id_estagio].fetched;
            },

            setCurrent(current, id_estagio){
                alert(current);
                alert(id_estagio);
                this.detailsInfos[id_estagio].pagination.current = current;
            },
            formatTipoPedido(acompanhamento){
                if(acompanhamento.pedido_contato_estado_id){
                    return ConverterHelper.getContatoStatus(acompanhamento.pedido_contato_estado_id);
                }else if(acompanhamento.pedido_visita_estado_id){
                    return ConverterHelper.getVisitaStatus(acompanhamento.pedido_visita_estado_id);
                }
            },
            formatDate(value){

                if(value){
                    return ConverterHelper.getDate(value, 'DD/MM/YYYY')
                }
                return '';

            },
            handleGetEstadosDetalhes(item, index = 0){

                this.tab  = index;
                this.getEstadosDetalhes(item);
            },
            getEstadosDetalhes(item){

                if(item.quantidade && this.detailsInfos[item.id_estagio].fetched === false){
                    const self = this;
                    const newFiltro = {...this.filtro};
                    newFiltro.data_ini = moment(this.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    newFiltro.data_fim = moment(this.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
                    this.modalLoading = true;
                    api.post('grafico/relatorio-franquias-funcionario-pedido-detalhes', {...newFiltro, id_estagio: item.id_estagio}).then(response => {
                        if(response.data.result.data.estagios){
                            self.detailsInfos[item.id_estagio].itens = response.data.result.data.estagios;
                        }
                        self.detailsInfos[item.id_estagio].fetched = true;
                        self.modalLoading = false;
                    }).catch(error => {
                        self.modalLoading = false;
                    })
                }

            },
            getDetailInfo(id_estagio){
                return this.detailsInfos[id_estagio].itens;
            },
            checkDetailInfo(id_estagio){
                return this.detailsInfos[id_estagio].itens.length;
            },
            openModalDetail() {
                const self = this;
                setTimeout(function () {

                    $('#modalDetail').modal('open');
                }, 500);
            },
            hideModalDetail() {
                this.showHeader = false;
                const self = this;
                $('#modalDetail').modal('close');
                 this.detailsInfos = {
                '2': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
                '3': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
                '9': {
                    pagination: {
                        current: 1,
                        qtd: 20
                    },
                    fetched: false,
                    itens: [],
                    total: 0
                },
            };


            },
            getDetalhes(id_funcionario){
                this.tab = 0;
                this.modalLoading = true;
                this.hideModalDetail();
                this.openModalDetail();
                const newFiltro = {...this.filtro};
                newFiltro.data_ini = moment(this.filtro.data_ini, 'DD/MM/YYYY').format('YYYY-MM-DD');
                newFiltro.data_fim = moment(this.filtro.data_fim, 'DD/MM/YYYY').format('YYYY-MM-DD');
                const self = this;
                this.filtro.id_funcionario = id_funcionario;
                api.post('grafico/relatorio-franquias-funcionario-detalhes', {...newFiltro, id_funcionario}).then(response => {
                    self.details = self.mapDetails(response.data.result.data.estagio);
                    self.modalLoading = false;
                    self.showHeader = true;
                    self.details.forEach(item => {
                        if(item.id_estagio == ESTAGIO_CHAMADA_TELEFONICA){
                            self.getEstadosDetalhes(item);
                        }
                    })


                })
            },
            setFraseOrder(){
                if(this.filtro.order == 'asc'){
                    this.fraseOrder = `Corretores de <b>pior</b> desempenho`;
                }else if(this.filtro.order == 'desc'){
                    this.fraseOrder = 'Corretores de <b>melhor</b> desempenho';
                }
            },
            showLoading(show = true){
                this.$parent.$emit('showLoading', show);
            },
            getSelectedId(selected){

                if(selected){
                    let id_franquia = this.funcionarios.filter(franquia => franquia.nome_funcionario === selected);
                   if(id_franquia.length){
                       id_franquia = id_franquia[0].id_funcionario;
                   }
                    return id_franquia;
                }else{
                    return selected;
                }
            },
            setOrder(order){
                if(this.filtro.order != order){
                    this.filtro.order = order;
                    this.filtro = Object.assign({}, this.filtro, { order });
                    this.setFraseOrder();
                }
            },
            cleanItem(id){
                let franquia_nome = this.funcionarios.filter(franquia => franquia.id_empresa === id);
                if(franquia_nome.length){
                    franquia_nome = franquia_nome[0].nome_empresa;
                }
                this.added = this.added.filter(item => item !== franquia_nome);
            },
            removeItem(franquia){
                this.removeId = this.getSelectedId(franquia);
                this.added = this.added.filter(item => item !== franquia);
                this.selectedId = null;
                this.selected   = null;
                this.$emit('remove');
            },

            onDateSelected(newValue, field) {
                this.filtro = Object.assign({[field]: newValue}, this.filtro);
            },

        }

    };
</script>



// WEBPACK FOOTER //
// src/components/relatorios/Funcionario.vue